import { render, staticRenderFns } from "./item-wrap.vue?vue&type=template&id=f2073330&scoped=true"
import script from "./item-wrap.vue?vue&type=script&lang=js"
export * from "./item-wrap.vue?vue&type=script&lang=js"
import style0 from "./item-wrap.vue?vue&type=style&index=0&id=f2073330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2073330",
  null
  
)

export default component.exports